/*
 * @Author: your name
 * @Date: 2021-02-27 16:09:58
 * @LastEditTime: 2021-09-26 10:34:21
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mamapai_background/src/store/getters.js
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  btns:state=> state.permission.btns,
  userId: state => state.user.userId,
  account: state => state.user.account
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js